import { Box, styled } from '@mui/material';
import { IconCheckmark, IconCloseCircle } from 'assets/img';
import { LwButton } from 'redesign';

type ButtonsProps = {
  onCancel: () => void;
  onSubmit: () => void;
};

export const Buttons = ({ onCancel, onSubmit }: ButtonsProps) => {
  return (
    <ButtonBigWrap>
      <ButtonWrap>
        <CancelButton onClick={onCancel} />
        <AcceptButton onClick={onSubmit} />
      </ButtonWrap>
    </ButtonBigWrap>
  );
};

const AcceptButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <LwButton
      onClick={onClick}
      iconColorMode="stroke"
      color="primary"
      startIcon={<IconCheckmark />}
    >
      Accept
    </LwButton>
  );
};

const CancelButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <LwButton
      onClick={onClick}
      iconColorMode="stroke"
      color="secondary"
      startIcon={<IconCloseCircle />}
    >
      Cancel
    </LwButton>
  );
};

const FlexRowBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));

const ButtonBigWrap = styled(FlexRowBox)(({ theme }) => ({
  marginTop: theme.spacing(10),
  marginBottom: theme.spacing(2),
  justifyContent: 'center',
}));

const ButtonWrap = styled(FlexRowBox)(({ theme }) => ({
  justifyContent: 'space-around',
  gap: theme.spacing(4),
}));
